import React from 'react';
import PropTypes from 'prop-types';
import {
  DialogTitle,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Grid,
} from '@material-ui/core';

function VerifyDialog(props) {
  const text = (props.verified !== null) ? `Verified: ${props.verified} towers.` : 'Are you really want to verify all towers from Smart-contract?';
  return (
    <Dialog
      open={props.open}
      onClose={(!props.verification) ? props.handleClose : null}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Tower list verification'}</DialogTitle>
      <DialogContent>
        {
          (!props.verification)
            ? <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
            : <Grid container align="center" justify="center">
                <CircularProgress />
              </Grid>
        }
      </DialogContent>
      <DialogActions>
        {
          (props.verified === null)
          && <Button onClick={props.handleVerify} variant="contained" color="secondary" disabled={props.verification}>
              Verify
            </Button>
        }
        <Button onClick={props.handleClose} variant="contained" color="primary" disabled={props.verification} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

VerifyDialog.propTypes = {
  open: PropTypes.bool,
  verification: PropTypes.bool.isRequired,
  handleVerify: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  verified: PropTypes.number,
};

export default VerifyDialog;
